/**
 * @module types/settings/conditionalFormat
 * @description 表格条件格式（存储字段名 `conditional_format`）
 */

export interface IColor {
  hexa: string;
  alpha: string;
}

export interface IColorTheme {
  type: 'solidColor';
  color: IColor[];
}

export interface IBarPercentageItem {
  id: string;
  table_code?: string;
  metric?: string;
  name?: string;
  colorTheme?: IColorTheme;
  min?: number | null;
  max?: number | null;
  customMin?: number | null;
  customMax?: number | null;
}

/** 持久化规则（不含 id）；id 仅 UI 编辑态在内存中生成 */
export interface IPersistedNumericalValueRule {
  operation: string;
  value: string[];
  color: IColor;
  icon: string;
}

export interface INumericalValueRule extends IPersistedNumericalValueRule {
  /** 仅组件内用于定位更新/删除，不写入 draft */
  id?: string;
}

export interface INumericalValueItem {
  id: string;
  /** 展示名称（column_display） */
  name?: string;
  /** 指标字段名（column_name） */
  metric?: string;
  table_code?: string;
  rules?: IPersistedNumericalValueRule[] | INumericalValueRule[];
}

export interface IConditionalFormatValue {
  table_bar_percentage?: IBarPercentageItem[];
  table_numerical_values?: INumericalValueItem[];
}

/**
 * conditional_format 缺省：未配置任何条件格式
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.conditional_format 为同一引用语义
 */
export const CONDITIONAL_FORMAT_DEFAULT: IConditionalFormatValue = Object.freeze(
  {},
) as IConditionalFormatValue;
